import { sanitizeHTML } from '@/lib/utils'
interface SecRecoveryProps {
	heading?: {
		title?: string
	}
	text?: {
		text?: string
	}
	text_bottom_info?: {
		title?: string
	}
	content_collection?: {
		id: string
		site_content_collections_id: {
			collection: {
				item: {
					title: string | null
					text: string | null
				}
			}[]
		}
	}[]
}
export const fields = [
	// headings
	'heading.title',

	// text
	'text.text',
	'text_bottom_info.title',

	// content collection
	'content_collection.id',
	'content_collection.site_content_collections_id.collection.item:site_content.title',
	'content_collection.site_content_collections_id.collection.item:site_content.text',

	'content_collection.site_content_collections_id.collection.*',
] as const

export default function SecRecovery({ data }: { data: SecRecoveryProps }) {
	if (!data) return null

	return (
		<section id='recovery' className='SecRecovery py-16 bg-neutral-50'>
			<div className='container'>
				<div className='grid grid-cols-1 gap-8'>
					{/* Header */}
					{data?.heading?.title && (
						<h2>
							{data.heading.title}
						</h2>
					)}

					<div className='grid grid-cols-1 lg:grid-cols-2 gap-8'>
						{/* Left Column */}
						<div
							className='flex flex-col gap-6'
							dangerouslySetInnerHTML={sanitizeHTML(data?.text?.text || '')}
						/>

						{/* Right Column - Timeline */}
						<div className='relative'>
							<div className='relative grid grid-cols-1 gap-8'>
								{/* Vertical Line */}
								<div className='absolute left-1/2 top-[15px] w-[1.3px] h-[calc(100%-40px)] bg-black' />

								{/* Timeline Items with Alternating Layout based on index */}
								{data?.content_collection?.map((item, index) => {
									const isReversed = index % 2 !== 0
									const titleItem =
										item.site_content_collections_id.collection.find(
											c => c.item.title
										)
									const textItem =
										item.site_content_collections_id.collection.find(
											c => c.item.text
										)

									return (
										<div
											key={item.id}
											className='grid grid-cols-[1fr,auto,1fr] items-center gap-5'
										>
											{isReversed ? (
												<>
													<div
														className='text-right text-lg 2xl:text-xl tracking-wide'
														dangerouslySetInnerHTML={sanitizeHTML(
															textItem?.item.text || ''
														)}
													/>
													<div className='w-4 h-4 bg-black rounded-full' />
													<span className='text-lg 2xl:text-xl tracking-wide font-medium'>
														{titleItem?.item.title || ''}
													</span>
												</>
											) : (
												<>
													<span className='text-right text-lg 2xl:text-xl tracking-wide font-medium'>
														{titleItem?.item.title || ''}
													</span>
													<div className='w-4 h-4 bg-black rounded-full' />
													<div
														className='text-lg 2xl:text-xl tracking-wide'
														dangerouslySetInnerHTML={sanitizeHTML(
															textItem?.item.text || ''
														)}
													/>
												</>
											)}
										</div>
									)
								})}
							</div>
							{/* Bottom Note */}
							{data?.text_bottom_info?.title && (
								<div className='flex justify-center mt-8'>
									<div className='inline-block bg-white p-4 rounded-lg'>
										<p className='text-base font-brandon uppercase tracking-wider text-center'>
											{data.text_bottom_info.title}
										</p>
									</div>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}
